import React from 'react';
import { Box, Alert, Button } from '@mui/material';
import { Sync, Block } from '@mui/icons-material';
import { useSyncValidationContext } from '../../context/SyncValidationContext';
import { useNavigate } from 'react-router-dom';

const SyncValidationGuard = ({ children, showWarning = true }) => {
  const { canAddNewData, syncBlock, syncWarning } = useSyncValidationContext();
  const navigate = useNavigate();

  // If data entry is blocked, show blocking message
  if (!canAddNewData && syncBlock) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert 
          severity="error" 
          icon={<Block />}
          sx={{ mb: 2 }}
        >
          <strong>Data Entry Blocked</strong>
          <br />
          {syncBlock.reason}
        </Alert>
        
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/syncdata')}
          startIcon={<Sync />}
          size="large"
        >
          Sync Data Now
        </Button>
      </Box>
    );
  }

  // If there's a warning but data entry is allowed, show warning
  if (showWarning && syncWarning && canAddNewData) {
    return (
      <Box>
        <Alert 
          severity="warning" 
          sx={{ mb: 2 }}
        >
          <strong>Sync Warning:</strong> {syncWarning.message}
        </Alert>
        {children}
      </Box>
    );
  }

  // If no issues, render children normally
  return children;
};

export default SyncValidationGuard; 